<template>
  <div :class="'navbar'+(loggedIn?' logged-in':'')">
    <div class="navbar-inner">
<!--      <div class="menu-btn" @click="toggleMenu"><img :src="menuIcon" /></div>-->
<!--      <div class="navbar-logo">-->
<!--        <router-link :to="logoLink"><img :src="logo" /></router-link>-->
<!--      </div>-->
      <div class="navbar-logo">
        <span v-if="subscriber">{{t("Hello, {0}", [subscriber.first_name])}}</span>
      </div>
      <div class="user-area">
        <a v-if="loggedIn" class="whatsapp-btn" :href="whatsappLink">
          <img src="https://fitness-api-media.s3.eu-central-1.amazonaws.com/1723045648961-whatsapp.png" />
        </a>
        <router-link v-if="loggedIn" class="todo-icon" to="/plan/feed/tasks">
          <img :src="todoIcon" />
        </router-link>
        <router-link v-if="loggedIn" class="user-icon" to="/plan/account">
          <img :src="womanIcon" />
        </router-link>
      </div>
      <MainMenu :active="menuOpen" :close-menu="closeMenu" :logged-in="loggedIn" :subscriber="subscriber" :on-logout="onLogout" />
    </div>
    <MemberMenu v-if="loggedIn" />
  </div>
</template>

<script>

import logo from '@/assets/images/logo-navbar.png';
import menuIcon from '@/assets/icons/menu.svg';
import womanIcon from '@/assets/icons/navbar/avatar.png';
import todoIcon from '@/assets/icons/navbar/todo.png';

import t from '@/lib/Locale';
import MainMenu from "@/components/ui/navbar/MainMenu";
import MemberMenu from "@/components/ui/navbar/PlanMenu";


export default {
  name: "Navbar",
  components: {MemberMenu, MainMenu},
  props: ['isLanding','loggedIn','subscriber','onLogout'],
  data() {
    return {
      logo,
      menuIcon,
      womanIcon, todoIcon,

      menuOpen: false
    }
  },

  computed : {
    logoLink() {
      return this.loggedIn ? '/plan/feed' : '/'
    },
    whatsappLink() {
      return 'https://wa.me/+972776047470?text=' + encodeURIComponent(t('default-whatsapp-message'))
    }
  },

  methods : {
    t,
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() { this.menuOpen = false }
  }
}
</script>
